export class Ratio {
  static readonly RATIO_1_1 = 'RATIO_1_1'
  static readonly RATIO_2_1 = 'RATIO_2_1'
  static readonly RATIO_4_1 = 'RATIO_4_1'
  static readonly RATIO_10_1 = 'RATIO_10_1'
}
